import React from 'react'
import Entities from './SectionEntity'
import { getEntityList } from '../../helpers/api'

const EntityList = props => {

    const { ContributorID, signalReady } = props

    const [data, setData] = React.useState(null)

    React.useEffect(() => {
        getEntityList(ContributorID)
            .then(data => {
                setData(data || [])
                signalReady && signalReady("entities")
            })
    }, [ContributorID])

    const types = [
        { id: "ae", label: "Accredited", title: "List of Accredited Entities" },
        { id: "pp", label: "Pipeline", title: "List of Entities in Pipeline" }
    ]

    return data && (
        <>
            {types.map(type => (
                <Entities key={type.id} data={data.filter(e => e.StageType === type.label)} type={type.id} Total={true} Title={type.title} />
            ))}
        </>
    )
}

export default EntityList